export const primaryIndustryOption = {
  opt1: 'Energy and Utilities',
  opt2: 'Government',
  opt3: 'Manufacturing',
  opt4: 'Oil and Gas',
  opt5: 'Travel and Transportation',
  opt6: 'Other',
};

export const businessChallengeOption = {
  opt1: 'Asset inspection',
  opt2: 'Asset reliability',
  opt3: 'Maintenance management',
  opt4: 'Sustainable asset management',
  opt5: 'Other',
};

export const assetManagementOption = {
  opt1: 'CMMS',
  opt2: 'APM',
  opt3: 'EAM',
  opt4: 'Spreadsheets',
  opt5: 'RCM',
  opt6: 'Visual inspection',
  opt7: 'Other',
};

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30Maas360 = '30BH6';
